/* You can add your custom scripts here */

/* Custom membership -> kwik minicart bridge */
document.addEventListener('DOMContentLoaded', function () {
  const membershipForms = document.querySelectorAll('.plan-card form[action="/cart/add"]');

  const formatMoney = (cents) => {
    if (window.Shopify && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, "{{amount}}".replaceAll('&nbsp;', ' '));
    }
    return (Number(cents || 0) / 100).toFixed(2);
  };

  const openKwikCart = () => {
    const cartButton = document.querySelector('.kwik-shop-icon');
    if (cartButton) {
      cartButton.click();
      return;
    }

    const drawer = document.getElementById('kwik-cart-drawer');
    const overlay = document.getElementById('cart-overlay');

    if (drawer && overlay) {
      drawer.hidden = false;
      overlay.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    }
  };

  const updateMiniCartCount = (cart) => {
    let countEl = document.getElementById('mini-cart-count') || document.querySelector('.kwik-mini-cart-count');

    if (!countEl && (cart.item_count || 0) > 0) {
      const cartButton = document.querySelector('.kwik-shop-icon');
      if (cartButton) {
        countEl = document.createElement('span');
        countEl.id = 'mini-cart-count';
        countEl.className = 'kwik-mini-cart-count';
        cartButton.append(countEl);
      }
    }

    if (!countEl) return;

    countEl.textContent = cart.item_count || 0;
    countEl.hidden = (cart.item_count || 0) === 0;
    countEl.setAttribute('aria-hidden', (cart.item_count || 0) === 0 ? 'true' : 'false');
  };

  const updateSubtotal = (cart) => {
    const subtotalEl = document.getElementById('cart-subtotal');
    if (subtotalEl) {
      subtotalEl.textContent = formatMoney(cart.items_subtotal_price || 0);
    }

    const totalLabel = document.querySelector('.cart-total span');
    if (totalLabel) {
      const count = cart.item_count || 0;
      totalLabel.textContent = `Subtotal (${count} ${count === 1 ? 'Item' : 'Items'})`;
    }
  };

  const renderCartItems = (cart) => {
    const contents = document.getElementById('cart-contents');
    if (!contents) return;

    if (!cart.items || !cart.items.length) {
      contents.innerHTML = `<p class="empty-cart-message">Your cart is empty.</p>`;
      return;
    }

    contents.innerHTML = cart.items.map((item) => {
      const image = item.image
        ? item.image.replace(/(\.jpe?g|\.png|\.webp)(\?.*)?$/i, '_100x$1')
        : '';

      return `
        <div class="cart-line" data-key="${item.key}">
          <img src="${image}" alt="">
          <div class="cart-title-wrapper">
            <div class="cart-line-title">${item.product_title}</div>
            <div class="cart-line-entries">Qty: ${item.quantity}</div>
          </div>
          <div class="line-remove" aria-label="Remove" data-key="${item.key}">
            ×
          </div>
        </div>
        <div class="qty-price" data-key="${item.key}">
          <div class="cart-line-meta">
            <div>${formatMoney(item.final_line_price)}</div>
          </div>
        </div>
      `;
    }).join('');
  };

  const refreshKwikCart = async () => {
    const cart = await fetch('/cart.js', {
      headers: { 'Accept': 'application/json' }
    }).then((r) => r.json());

    updateMiniCartCount(cart);
    updateSubtotal(cart);
    renderCartItems(cart);

    const multiplierWrapper = document.getElementById('multiplier-wrapper');
    if (multiplierWrapper) {
      multiplierWrapper.style.display = cart.items && cart.items.length ? 'block' : 'none';
    }

    const minicartCollections = document.getElementById('minicart-collections');
    if (minicartCollections) {
      minicartCollections.style.display = cart.items && cart.items.length ? 'none' : 'block';
    }

    document.dispatchEvent(new CustomEvent('cart:updated'));
    return cart;
  };

  const setButtonLoading = (btn, isLoading) => {
    if (!btn) return;

    if (isLoading) {
      btn.dataset.loading = 'true';
      btn.dataset.originalHtml = btn.innerHTML;
      btn.disabled = true;
      btn.style.opacity = '0.6';
      btn.innerHTML = 'Adding...';
      return;
    }

    btn.disabled = false;
    btn.style.opacity = '';
    if (btn.dataset.originalHtml) {
      btn.innerHTML = btn.dataset.originalHtml;
      delete btn.dataset.originalHtml;
    }
    delete btn.dataset.loading;
  };

  const normalizeOptionValue = (value) => {
    return (value || '').toString().trim().toLowerCase();
  };

  const getProductOptionsElement = (form) => {
    return form.querySelector('product-options') || document.querySelector('product-options');
  };

  const getSelectedOptions = (form) => {
    const selectedOptions = {};
    const productOptions = getProductOptionsElement(form);

    if (!productOptions) return selectedOptions;

    productOptions.querySelectorAll('.product-option-picker__list').forEach((list) => {
      const chosen = list.querySelector('.product-option-picker__list-item.chosen');
      if (chosen && list.dataset.optionName) {
        selectedOptions[list.dataset.optionName] = chosen.dataset.optionValue;
      }
    });

    return selectedOptions;
  };

   const findVariantIdFromSelectText = (form, selectedOptions) => {
    const variantSelect = form.querySelector('select[name="id"]');
     
    const selectedValues = Object.values(selectedOptions).map(normalizeOptionValue);

    if (!variantSelect || !selectedValues.length) return null;

    const matchingOption = Array.from(variantSelect.options).find((option) => {
      if (!option.value || option.value === 'none' || option.disabled) return false;

      const optionParts = option.textContent
        .split('/')
        .map(normalizeOptionValue);

     
      if (optionParts.length !== selectedValues.length) return false;

      
      return selectedValues.every((selectedValue, index) => optionParts[index] === selectedValue);
    });

    if (!matchingOption) return null;

    variantSelect.value = matchingOption.value;
    return matchingOption.value;
  };

  const getProductJson = async (form) => {
    const productOptions = getProductOptionsElement(form);
    const handle = productOptions && productOptions.dataset.productHandle;

    if (!handle) return null;

    const response = await fetch(`${window.Shopify && Shopify.routes ? Shopify.routes.root : '/'}products/${handle}.js`, {
      headers: { 'Accept': 'application/json' }
    });

    if (!response.ok) return null;
    return response.json();
  };

  const getValidVariantId = async (form) => {
    const variantSelect = form.querySelector('select[name="id"]');
    const selectedOptions = getSelectedOptions(form);
    const selectedOptionNames = Object.keys(selectedOptions);
    const selectTextVariantId = findVariantIdFromSelectText(form, selectedOptions);

    if (selectTextVariantId) {
      return selectTextVariantId;
    }

    if (selectedOptionNames.length) {
      const product = await getProductJson(form);

      if (product && product.options && product.variants) {
        const productOptionNames = product.options.map((option) => {
          return typeof option === 'string' ? option : option.name;
        });
        const matchingVariants = product.variants.filter((variant) => {
          return selectedOptionNames.every((optionName) => {
            const optionIndex = productOptionNames.indexOf(optionName);
            return optionIndex > -1 && variant.options[optionIndex] === selectedOptions[optionName];
          });
        });
        const matchedVariant = matchingVariants.find((variant) => variant.available) || matchingVariants[0];

        if (matchedVariant) {
          if (variantSelect) variantSelect.value = matchedVariant.id;
          return matchedVariant.id;
        }
      }
    }

    if (!variantSelect) return null;

    if (variantSelect.value && variantSelect.value !== 'none') {
      return variantSelect.value;
    }

    const validOption = Array.from(variantSelect.options).find((option) => {
      return option.value && option.value !== 'none' && !option.disabled;
    });

    if (!validOption) return null;

    variantSelect.value = validOption.value;
    return validOption.value;
  };

  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('.product-summary .product-summary__add-to-cart');
    if (!btn || btn.closest('.plan-card')) return;
    if (btn.dataset.loading === 'true' || btn.disabled) return;

    const form = btn.closest('form[action="/cart/add"], form[action*="/cart/add"], .product-options-form');
    if (!form) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    setButtonLoading(btn, true);

    try {
      const variantId = await getValidVariantId(form);
      if (!variantId) throw new Error('Please select a valid variant');

      const formData = new FormData(form);
      formData.set('id', variantId);

      if (!formData.get('quantity')) {
        formData.set('quantity', '1');
      }

      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      });

      const payload = await addRes.json();
      if (!addRes.ok || payload.status === 422) {
        throw new Error(payload.description || 'Unable to add product');
      }

      await refreshKwikCart();
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
      openKwikCart();
    } catch (err) {
      console.error('Product add to cart failed:', err);
      const action = btn.closest('.product-summary__action');
      if (action) {
        let error = action.querySelector('.error');
        if (!error) {
          error = document.createElement('p');
          error.className = 'error';
          action.prepend(error);
        }
        error.textContent = err.message;
      }
    } finally {
      setButtonLoading(btn, false);
    }
  }, true);

  membershipForms.forEach((form) => {
    const btn = form.querySelector('button[type="submit"]');
    if (!btn) return;

    btn.addEventListener('click', async function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      if (btn.dataset.loading === 'true') return;
      btn.dataset.loading = 'true';

      const originalHtml = btn.innerHTML;
      btn.disabled = true;
      btn.style.opacity = '0.6';
      btn.innerHTML = 'Adding...';

      try {
        const formData = new FormData(form);

        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        });

        if (!addRes.ok) {
          throw new Error('Add to cart request failed');
        }

        await refreshKwikCart();
        openKwikCart();
      } catch (err) {
        console.error('Membership add to cart failed:', err);
      } finally {
        btn.disabled = false;
        btn.style.opacity = '';
        btn.innerHTML = originalHtml;
        delete btn.dataset.loading;
      }
    }, true);
  });

  document.addEventListener('click', async function (e) {
    const removeBtn = e.target.closest('.line-remove[data-key]');
    if (!removeBtn) return;

    const key = removeBtn.getAttribute('data-key');
    if (!key) return;

    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ id: key, quantity: 0 })
      });

      await refreshKwikCart();
    } catch (err) {
      console.error('Remove from cart failed:', err);
    }
  });
});

// -------------------------------------

// 1. Define the logic to check the state and update the button
function updateSubmitButtonState() {
  const isUnavailableSelected = document.querySelector('ul.product-option-picker__list > li.unavailable-variant.chosen');
  const submitButton = document.querySelector('.product-form__buttons > button');
  
  if (submitButton) {
    const textSpanWrapper = submitButton.querySelector('span[data-text]');
    const textSpanInner = submitButton.querySelector('span > span');

    if (isUnavailableSelected) {
      submitButton.classList.add('unavailable');
      if (textSpanWrapper) textSpanWrapper.setAttribute('data-text', 'Out of stock');
      if (textSpanInner) textSpanInner.textContent = 'Out of stock';
    } else {
      submitButton.classList.remove('unavailable');
      if (textSpanWrapper) textSpanWrapper.setAttribute('data-text', 'Add to cart');
      if (textSpanInner) textSpanInner.textContent = 'Add to cart';
    }
  }
}

// 2. Define the element to watch
const variantContainer = document.querySelector('.product-summary__variant-picker');

// 3. Initialize the Observer
if (variantContainer) {
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      // Check if a class changed OR if new HTML elements were added/removed
      if ((mutation.type === 'attributes' && mutation.attributeName === 'class') || mutation.type === 'childList') {
        
        updateSubmitButtonState();
        
        // Break so we only run the check once per batch of updates
        break; 
      }
    }
  });

  // 4. Observer Configuration
  const config = { 
    attributes: true,          
    attributeFilter: ['class'],
    childList: true,           // Catches elements being added/removed
    subtree: true              // Catches changes deep inside the container
  };

  observer.observe(variantContainer, config);

  // Run on initial load
  updateSubmitButtonState();
}


  // if (window.location.pathname === '/pages/session/' || window.location.pathname === '/pages/session') {
  //   window.location.replace('/');
  // }
